export default __webpack_public_path__ + "static/media/share.6fe7f310.svg";